import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
export default (function (deviceId, organisationId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_DEVICE_SETTINGS, {
        organisationId: organisationId,
        device: deviceId
    });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true });
    return request.execute();
});
